import { WalletDrawerTranslations } from ".";

export const WALLET_DRAWER_EN_US: WalletDrawerTranslations = {
	title: "Your Zig Wallet",
	totalBalance: "Total Balance",
	transactions: "Transactions",
	withdrawal: "Withdrawal",
	anticipation: "Anticipation",
	ticketPayment: "Ticket Payment",
	transferBetweenPlaces: "Transfer Between Places",
};
